import { Link } from 'react-router-dom';

const Footer = () => {
  const navigation = [
    { name: 'Accueil', href: '/' },
    { name: 'Boutique', href: '/boutique' },
    { name: 'QUADLUX™', href: '/quadlux' },
    { name: 'VYBE™', href: '/vybe' },
    { name: 'Formations', href: '/formations' },
    { name: 'Presets', href: '/presets' },
    { name: 'Collaborations', href: '/collaborations' },
    { name: 'Contact', href: '/contact' },
  ];

  const socialLinks = [
    {
      name: 'WhatsApp',
      href: 'https://wa.me/33658126340',
      icon: 'ri-whatsapp-line',
    },
    {
      name: 'Instagram',
      href: 'https://instagram.com/maison.zeus',
      icon: 'ri-instagram-line',
    },
    {
      name: 'TikTok',
      href: 'https://www.tiktok.com/@adofficielo',
      icon: 'ri-tiktok-line',
    },
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=100080958240528',
      icon: 'ri-facebook-line',
    },
    {
      name: 'YouTube',
      href: '#',
      icon: 'ri-youtube-line',
    },
  ];

  return (
    <footer className="bg-black border-t border-orange-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">
              VYBE <span className="text-orange-500">PARIS</span>
            </h3>
            <p className="text-gray-400 text-sm">
              Créer • Influencer • Voyager
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-[#FF8A00] transition-colors">Livraison en 5 jours</a></li>
              <li><a href="#" className="text-gray-400 hover:text[#FF8A00] transition-colors">Livraison gratuite dès 90€</a></li>
              <li><a href="#" className="text-gray-400 hover:text[#FF8A00] transition-colors">Retours gratuits 30j</a></li>
              <li><a href="#" className="text-gray-400 hover:text[#FF8A00] transition-colors">Service client 24/7</a></li>
              <li><a href="#" className="text-gray-400 hover:text[#FF8A00] transition-colors">Garantie qualité</a></li>
            </ul>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Navigation</h4>
            <div className="grid grid-cols-2 gap-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Suivez-nous</h4>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:text-orange-500 hover:bg-orange-500/10 transition-all duration-300"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 VYBE PARIS — Créer • Influencer • Voyager.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
